import { render } from "./RecipeSection.vue?vue&type=template&id=b9dfdd6c&scoped=true"
import script from "./RecipeSection.vue?vue&type=script&lang=js"
export * from "./RecipeSection.vue?vue&type=script&lang=js"

import "./RecipeSection.vue?vue&type=style&index=0&id=b9dfdd6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9dfdd6c"]])

export default __exports__